import { OnInit, Component, Input, ViewEncapsulation } from "@angular/core";
import { SurveyDTO } from "src/DTOs/PatientProcedures/Models/SurveyDTO";
import { CommService } from "src/services/comm-service";
import { array } from "@amcharts/amcharts4/core";
import { SurveyQuestionDTO } from "src/DTOs/PatientProcedures/Models/SurveyQuestionDTO";
import { SurveyService } from "src/services/survey.service";
import { AuthService } from "src/auth/auth.service";
import { SurveyType } from "src/DTOs/Organisations/Models/ProcedureProtocolMessageTemplateDTO";

@Component({
  selector: "app-survey-details",
  templateUrl: "survey-details.component.html",
  styleUrls: ["survey-details.component.scss"],
})
export class SurveyDetailsComponent implements OnInit {
  constructor(private commsService: CommService, private surveyService: SurveyService, private auth: AuthService) {}

  ngOnInit(): void {}

  survey: SurveyDTO;
  displayedColumns = ["question", "response_type"];

  @Input()
  surveyName: string;

  @Input()
  get surveyId(): string {
    return this._surveyId;
  }
  set surveyId(surveyId: string) {
    this._surveyId = surveyId;
    if (this._surveyType) this.getSurvey(surveyId);
  }
  private _surveyId: string = "";
  
  @Input()
  get surveyType(): SurveyType {
    return this._surveyType || "None";
  }
  set surveyType(surveyType: SurveyType) {
    this._surveyType = surveyType;
    if (this._surveyId) this.getSurvey(this._surveyId);
  }
  private _surveyType: SurveyType = "None";

  get sortedQuestions(): SurveyQuestionDTO[] {
    if (this.survey !== undefined) {
      return this.survey.questions.sort((x, y) => x.position - y.position);
    } else {
      return null;
    }
  }

  getSurvey(surveyId) {
    if (this._surveyType == "External") {
      this.commsService.GetSurveyByExternalId(surveyId).subscribe(
        (response: SurveyDTO) => {
          this.survey = response;
        },
        (error) => {
          console.error(error);
        }
      );
    }
    else if (this._surveyType == "FollowApp") {
      this.surveyService.GetSurveyQuestionStub(surveyId, this.auth.getClaims().organization_id).subscribe(x => {
        this.survey = {
          surveyId: x.id,
          surveyTitle: x.name,
          questions: x.questions.map(q => {
            return {
              title: q.questionText,
              type: q.replyType
            }
          }) as any
        } as any;
      });
    }
  }
}
